import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Row, Col, Alert, Button, Image } from 'react-bootstrap';
import { config } from '../../config';

const Register = () => {
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [registerButtonDisabled, setRegisterButtonDisabled] = useState(false);

    const handleRegister = async (e) => {
        e.preventDefault();

        if (!firstName) {
            setErrorMsg('First name filed is required');
            return;
        }

        if (!lastName) {
            setErrorMsg('Last name filed is required');
            return;
        }

        if (!email) {
            setErrorMsg('E-mail filed is required');
            return;
        }

        if (!password || password.length < 8) {
            setErrorMsg('Password not valid, Password should be at least 8 characters');
            return;
        }

        if (password !== confirmPassword) {
            setErrorMsg('Password and Confirm Password not match');
            return;
        }

        setRegisterButtonDisabled(true);
        const response = await fetch(`${config.url}/auth/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ firstName, lastName, email, password, confirmPassword })
        });

        const resData = await response.json();

        setRegisterButtonDisabled(false);

        if (!response.ok) {
            let showErrorMsg = 'Error has occurred when trying to register';
            if (resData && resData.message) {
                showErrorMsg = resData.message + ' ';
            }
            if (resData && resData.data && resData.data[0] && resData.data[0].msg) {
                showErrorMsg += resData.data[0].msg;
            }
            setErrorMsg(showErrorMsg);
            return;
        }

        setErrorMsg('');

        navigate('/activate-mail-msg');
    }

    const handleEnterKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleRegister(e);
        }
    }

    return (
        <div style={{ backgroundColor: '#29303d', width: '100%', height: '100vh', overflow: 'auto' }}>
            <Container>
                <Row className="justify-content-md-center text-center pt-4">
                    <Col sm="12" md="4">
                        <Image src="/images/floworglogo.png" style={{ width: '80%' }} />
                    </Col>
                </Row>
                <Row className="justify-content-md-center text-center pt-4">
                    <Col sm="12" md="4">
                        <h3 style={{ color: '#fed78e' }}>Register</h3>
                    </Col>
                </Row>
                {errorMsg &&
                    <Row className="justify-content-md-center mt-3">
                        <Col sm="12" md="4">
                            <Alert variant="danger">{errorMsg}</Alert>
                        </Col>
                    </Row>
                }
                <Row className="justify-content-md-center mt-3">
                    <Col sm="12" md="4">
                        <Form>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#fed78e' }}>First Name *</Form.Label>
                                <Form.Control type="text" placeholder="First Name" onChange={(e) => { setFirstName(e.target.value) }} />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#fed78e' }}>Last Name *</Form.Label>
                                <Form.Control type="text" placeholder="Last Name" onChange={(e) => { setLastName(e.target.value) }} />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#fed78e' }}>Email Address *</Form.Label>
                                <Form.Control type="email" placeholder="Email" onChange={(e) => { setEmail(e.target.value) }} />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#fed78e' }}>Password *</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Password"
                                    onChange={(e) => { setPassword(e.target.value) }}
                                    onKeyDown={handleEnterKeyPress}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ color: '#fed78e' }}>Confirm Password *</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Confirm Password"
                                    onChange={(e) => { setConfirmPassword(e.target.value) }}
                                    onKeyDown={handleEnterKeyPress}
                                />
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
                <Row className="justify-content-md-center text-center mt-5 mb-5">
                    <Col sm="12" md="4">
                        <Button
                            variant="gray"
                            style={{ backgroundColor: '#fed78e', color: '#29303d', width: '150px' }}
                            onClick={handleRegister}
                            disabled={registerButtonDisabled}>Register</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Register;
